import Modal from '../../shared/Modal';
import * as React from 'react';
import {Async} from 'react-select';
import {FormattedMessage, injectIntl, InjectedIntlProps, defineMessages} from 'react-intl';
import {useState, useEffect, useRef} from 'react';

type IFormat = (value: string | null) => string | null;

function usePrevious(value: any): any {
    const ref = useRef();
    useEffect(() => {
        ref.current = value;
    });
    return ref.current;
}

interface IField {
    label: string;
    name: string;
    initialValue?: string;
    isValid?: (value: string) => boolean;
    format?: IFormat;
    required?: boolean;
    password?: boolean;
    errorText?: string;
    hidden?: boolean;
    editable?: boolean;
    helpText?: any;
}

interface IStringMap {
    [s: string]: string;
}

interface IUpdateModalProps {
    fields: IField[];
    modalId: string;
    onSubmit: (values: IStringMap) => undefined | void | Promise<undefined | void>;
}

export default (props: IUpdateModalProps) => {
    const [values, setValues] = useState({});
    // const [submitted, setSubmitted] = useState(false);
    const [validValues, setValidValues] = useState({});
    const prevFields: IField[] | undefined = usePrevious(props.fields);

    useEffect(() => {
        const initialValues = {};
        const initialValid = {};
        for (const field of props.fields) {
            if (prevFields) {
                const fi = (prevFields || []).find((f: IField) => f.name === field.name);
                if (fi && fi.initialValue === initialValues[field.name]) continue;
            }
            initialValues[field.name] = field.initialValue;
            initialValid[field.name] = true;
        }
        setValues(initialValues);
        setValidValues(initialValid);
    }, [props.fields]);

    const setValue = (name: string, value: string) => {
        setValues({...values, [name]: value});
    };

    const setValidValue = async (name: string, valid: boolean) => {
        await setValidValues({...validValues, [name]: valid});
    };

    const testValue = async (field: IField) => {
        const validator = field.isValid || ((v: string) => !!v);
        const value = values[field.name];
        let valid: boolean;
        if (!value) {
            valid = !!value || !field.required || false;
            await setValidValue(field.name, valid);
            return valid;
        }
        valid = (value === '' && !field.required) || validator(value);
        await setValidValue(field.name, valid);
        return valid;
    };

    const submit = async () => {
        let allValid = true;
        for (const field of props.fields) {
            allValid = allValid && (await testValue(field));
        }
        if (allValid) {
            props.onSubmit(values);
        }
    };

    const action = [
        <button
            type="button"
            className="btn"
            key={props.modalId + '-cancel-button'}
            data-dismiss="modal"
            id={props.modalId + '-close-button'}>
            <FormattedMessage id="dash.profile.edit.cancel" defaultMessage="Cancel" />
        </button>,
        <button
            type="button"
            className="btn btn-primary"
            onClick={submit}
            key={props.modalId + '-submit-button'}
            id={props.modalId + '-submit-button'}>
            <FormattedMessage id="dash.profile.edit.submit" defaultMessage="Update" />
        </button>,
    ];

    const renderFormField = (field: IField) => {
        if (field.hidden) return <React.Fragment key={field.name} />;
        return (
            <div className="form-group" key={field.name}>
                <label htmlFor={field.name}>{field.label}</label>
                <input
                    className={`form-control ${
                        validValues[field.name] === false ? 'is-invalid' : ''
                    }`}
                    id={field.name}
                    value={values[field.name] || ''}
                    onChange={(e: React.FormEvent<HTMLInputElement>) =>
                        setValue(field.name, e.currentTarget.value)
                    }
                    onBlur={() => testValue(field)}
                    type={field.password ? 'password' : 'text'}
                    disabled={field.editable === false}
                />
                <div className="invalid-feedback">
                    {field.errorText || 'This field is required'}
                </div>
                <div className="text-muted" style={{fontSize: 14}}>
                    {field.helpText}
                </div>
            </div>
        );
    };

    const updateFunction = (field: IField) => {};

    return (
        <React.Fragment>
            <Modal id={props.modalId} title="Update" actionButtons={action}>
                <form key={props.modalId + '-form'}>
                    {props.fields.map((field) => renderFormField(field))}
                </form>
            </Modal>
        </React.Fragment>
    );
};



// WEBPACK FOOTER //
// ./src/client/shared/UpdateModal.tsx